import { render, staticRenderFns } from "./RecurringOrderDetails.vue?vue&type=template&id=d45f24fc&scoped=true&"
import script from "./RecurringOrderDetails.vue?vue&type=script&lang=js&"
export * from "./RecurringOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./RecurringOrderDetails.vue?vue&type=style&index=0&id=d45f24fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45f24fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
